module.exports = __webpack_public_path__ + "media/images/mymp-logo-light-7accb5f9ae488b417da982957c692159.svg";